import { AppState } from '@/store/mainModule/state';
import { mutations } from '@/store/mainModule/mutations';
import { actions } from '@/store/mainModule/actions';
import { getters } from '@/store/mainModule/getters';
import { Module } from 'vuex';
import { RootState } from '@/store/root.state';

const namespaced: boolean = true;
export const mainModule: Module<AppState, RootState> = {
  namespaced,
  state: new AppState(),
  getters,
  actions,
  mutations,
};
